export default {
  headerContent: {
    title: 'Ray Sigorta Zorunlu Trafik Sigortası Teklif Al',
    slogan: "Trafik Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'TRAFİK SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Ray Sigorta Zorunlu Trafik Sigortası',
    description: {
      title: 'Ray Sigorta Zorunlu Trafik Sigortası Nedir? ',
      content: [
        'Ray Sigorta zorunlu trafik sigortası ürünü ile üçüncü şahıslara karşı sorumluluklarınızı güvence altına alabilirsiniz. Yaptırılması kanunen zorunlu olan trafik sigortası poliçenizi Ray Sigorta güvencesinde alabilirsiniz.',
        'Direksiyon başındayken sizi finansal olarak korumak için araba sigortası gereklidir. Kaza durumunda karşı tarafa vereceğiniz zarar ve hasarlarda mağdur olmamak için trafik sigortası poliçenizi günü geçmeden yeniletmelisiniz. İster sadece temel sorumluluk sigortanız olsun, ister tam oto sigortanız olsun, mümkün olan en iyi anlaşmayı aldığınızdan emin olmanız son derece önemlidir.'
      ]
    },
    subContent: {
      title: 'Türk Nippon Sigorta Zorunlu Trafik Sigortası Neleri Kapsar?',
      content: [
        {
          paragraph:
            'Yolda araç kullanmak için hepimizin araba sigortasına ihtiyacı vardır, ancak doğru sigorta türünü bulmak zor olabilir. Alokasko, size temel konular hakkında daha fazla bilgi vermeyi ve bir poliçe seçerken daha bilinçli bir seçim yapmanıza yardımcı olmayı amaçlamaktadır.',
          subList: null
        },
        {
          paragraph:
            'Trafik sigortası tüm motorlu araç sahiplerinin yaptırması zorunlu olan sigorta ürünüdür. Bu ürün sayesinde karayolunda kaza sonucunda üçüncü kişilerin uğrayacağı zararları poliçe limitleri kapmasında karşılanabilir.',
          subList: null
        },
        {
          paragraph:
            'Araba sigortası sizi mali kayıplara karşı korur.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Trafik Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Trafik Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Trafik Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Trafik Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Trafik Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Ray Sigorta Trafik Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
  ]
}
